module.exports = __webpack_public_path__ + "img/expandir.ae67485d.svg";